import { Controller } from "@hotwired/stimulus"

// Toggles a single location's "Override / Inherit" state inside an expanded
// health-system drilldown.
//
// Default (Inherit): the per-location settings panel is hidden and its inputs
// are `disabled`, so the panel does NOT contribute to the form. The location
// inherits whatever the HS-level defaults are at submit time.
//
// Override active: the per-location panel is visible, its inputs are
// enabled, and any values the user chooses are sent as
// `location_settings[<id>][...]` — replacing the HS defaults entirely for
// that location (all-or-nothing).
export default class extends Controller {
  static targets = ["panel", "button"]

  toggle(event) {
    if (event) event.preventDefault()
    if (!this.hasPanelTarget) return

    const willBeActive = this.panelTarget.classList.contains("hidden")
    this.panelTarget.classList.toggle("hidden", !willBeActive)

    // Enable / disable just the form inputs inside the panel so submission
    // accurately reflects the user's choice. We scope this to selects,
    // textareas, and hidden inputs inside the panel; we don't want to
    // disable, e.g., the row's checkbox or the HS-level inputs.
    this.panelTarget
      .querySelectorAll("select, textarea, input[type=hidden], input[type=search]")
      .forEach((el) => {
        el.disabled = !willBeActive
      })

    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = willBeActive ? "Inherit" : "Override"
    }
  }
}
